module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "p-layout-breadcrumb"
  }, [_c('el-row', {
    attrs: {
      "type": "flex",
      "align": "middle"
    }
  }, [_c('el-col', {
    attrs: {
      "span": 3
    }
  }, [_c('h3', [_vm._v("设备列表")])]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 2
    }
  }, [_c('el-button', {
    attrs: {
      "type": "info"
    },
    on: {
      "click": _vm.handleAdd
    }
  }, [_vm._v("添加设备")])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 2
    }
  }, [_c('el-button', {
    attrs: {
      "type": "success"
    },
    on: {
      "click": _vm.handleBack
    }
  }, [_vm._v("返回")])], 1)], 1)], 1), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    attrs: {
      "data": _vm.fetchList,
      "element-loading-text": "拼命加载中"
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "productId",
      "label": "ID"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "deviceId",
      "label": "机器序列号"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "productIdentity",
      "label": "条形码编码"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "storageName",
      "label": "所在仓库"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "context": _vm._self,
      "label": "状态"
    },
    inlineTemplate: {
      render: function() {
        var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
          return _c('div', [(_vm.row.isOnline) ? _c('span', [_vm._v("上架")]) : _c('span', [_vm._v("下架")])])
        
      },
      staticRenderFns: []
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "context": _vm._self,
      "width": "200",
      "label": "操作"
    },
    inlineTemplate: {
      render: function() {
        var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
          return _c('span', [_c('el-button', {
            attrs: {
              "type": "text",
              "size": "small"
            },
            on: {
              "click": function($event) {
                return _vm.handleOrder(_vm.$index, _vm.row)
              }
            }
          }, [_vm._v("查看租赁历史")]), _vm._v(" "), _c('el-button', {
            attrs: {
              "type": "text",
              "size": "small"
            },
            on: {
              "click": function($event) {
                return _vm.handleEdit(_vm.$index, _vm.row)
              }
            }
          }, [_vm._v("编辑")]), _vm._v(" "), (!_vm.row.isOnline) ? _c('el-button', {
            attrs: {
              "type": "text",
              "size": "small"
            },
            on: {
              "click": function($event) {
                return _vm.handleOnline(_vm.$index, _vm.row)
              }
            }
          }, [_vm._v("上架")]) : _vm._e(), _vm._v(" "), (_vm.Role === '1' && _vm.row.isOnline) ? _c('el-button', {
            attrs: {
              "type": "text",
              "size": "small"
            },
            on: {
              "click": function($event) {
                return _vm.handleOff(_vm.$index, _vm.row)
              }
            }
          }, [_vm._v("下架")]) : _vm._e()], 1)
        
      },
      staticRenderFns: []
    }
  })], 1), _vm._v(" "), _c('el-pagination', {
    attrs: {
      "current-page": _vm.currentPage,
      "page-size": 20,
      "layout": "total, prev, pager, next",
      "total": _vm.totalNum
    },
    on: {
      "size-change": _vm.handleSizeChange,
      "current-change": _vm.handleCurrentChange,
      "update:currentPage": function($event) {
        _vm.currentPage = $event
      },
      "update:current-page": function($event) {
        _vm.currentPage = $event
      }
    }
  }), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "租赁历史",
      "visible": _vm.dialogFormVisible
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogFormVisible = $event
      }
    }
  }, [_c('el-form', {
    attrs: {
      "model": _vm.form
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "上一个租赁客户ID",
      "label-width": "150px"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.form.lastOrderUserId))])]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "上一个租赁客户姓名",
      "label-width": "150px"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.form.lastOrderUsername))])]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "上一次租赁订单号",
      "label-width": "150px"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.form.lastOrderNo))])]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "发布时间",
      "label-width": "150px"
    }
  }, [_c('span', [_vm._v(_vm._s(new Date(_vm.form.created).getFullYear() + '-' + (new Date(_vm.form.created).getMonth() + 1) + '-' + new Date(_vm.form.created).getDate() + ' ' + new Date(_vm.form.created).getHours() + ':' + new Date(_vm.form.created).getMinutes() + ':' + new Date(_vm.form.created).getSeconds()) + " ")])]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "累计租赁次数",
      "label-width": "150px"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.form.orderCount))])]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "累计租赁天数",
      "label-width": "150px"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.form.dayCount))])]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "累计租赁资金",
      "label-width": "150px"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.form.rentalSum))])])], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.dialogFormVisible = false
      }
    }
  }, [_vm._v("关闭")])], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-67939790"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/product/Equipment.vue
// module id = 737
// module chunks = 1